import React from 'react';
import { connect } from 'react-redux';

import LINK from 'constants/link.const';
import { withTranslation } from 'providers/GILT.provider';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import { fromPropsToQuery, fromPropsToQueryString } from 'utils/converters/props/path.util';
import navFor from 'utils/links/navFor.util';

import PopupModalContainer from 'common/PopupModal';
import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';

import { getRoles } from './actions';
import RolesScreenContainer from './RolesScreen';

class RolesScreenWrap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFooterButtonActive: false,
      errorMessage: '',
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.salon) {
      navFor('RolesScreenWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
    }
    this.checkFooterButton(this.props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.roles.length === 0) {
      navFor('RolesScreenWrap.componentDidMount()', this.props).push({
        pathname: LINK.onboardingAddRole,
        search: fromPropsToQueryString(this.props),
      });
    }
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.isFetching && !nextProps.isPosting && nextProps.roles.length === 0) {
      navFor('RolesScreenWrap.componentWillReceiveProps()', this.props).push({
        pathname: LINK.onboardingAddRole,
        search: fromPropsToQueryString(this.props),
      });
    }
    this.checkFooterButton(nextProps);
  }

  onAddRoleClick = () => {
    navFor('RolesScreenWrap.onAddRoleClick()', this.props).push({
      pathname: LINK.onboardingAddRole,
      search: fromPropsToQueryString(this.props),
    });
  };

  onEditClick = (roleName, id) => {
    const state = { roleName, id };
    navFor('RolesScreenWrap.onEditClick()', this.props).push({
      pathname: LINK.onboardingAddRole,
      state,
      search: fromObjectToQueryString({ ...fromPropsToQuery(this.props), ...state }),
    });
  };

  onFooterButtonClicked = () => {
    if (this.state.isFooterButtonActive) {
      navFor('RolesScreenWrap.onFooterButtonClicked()', this.props).push({
        pathname: LINK.onboardingCategories,
        search: fromPropsToQueryString(this.props),
      });
    }
  };

  checkFooterButton = (props) => {
    if (props.roles.length > 0) {
      this.setState({ isFooterButtonActive: true });
    } else {
      this.setState({ isFooterButtonActive: false });
    }
  };

  hideError = () => void this.setState({ errorMessage: '' });

  render() {
    const { t } = this.props;

    return (
      <div data-bem="RolesScreenWrap" className="content-wrap">
        {this.state.errorMessage && <PopupModalContainer popupTitle={t('common.error')} popupMessage={this.state.errorMessage} buttonText={t('common.buttons.okay')} buttonCallback={this.hideError} />}

        <HeaderContainer titleFirstPart={t('register.roleScreenWrap.title')} description={t('register.roleScreenWrap.subtitle')} />

        <RolesScreenContainer
          salon={this.props.salon}
          onDotMenuEditClick={this.onEditClick}
          onAddRoleClick={this.onAddRoleClick}
          editedRolesIds={[]}
          settingsSavedRolesIDs={[]}
          settingsErrorRolesIDs={[]}
        />

        <OnboardingFooter
          isFooterButtonActive={this.state.isFooterButtonActive}
          onButtonClick={this.onFooterButtonClicked}
          extraButtonTitle={t('register.roleScreenWrap.addButton')}
          onExtraButtonClick={this.onAddRoleClick}
          isLoading={this.props.isFetching || this.props.isPosting}
        />

        {(this.props.isPosting || this.props.isFetching) && <div data-bem="RolesScreenWrap__load-blocker" className="load-blocker" />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { cognito, onboarding, currentSalon } = state;
  const { roles } = onboarding;
  const { isFetching, isPosting, deleteMessage } = roles;

  return {
    ...roles,
    cognito,
    salon: currentSalon,
    isFetching,
    isPosting,
    deleteMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRoles(salonId) {
      dispatch(getRoles(salonId));
    },
  };
}

// this extra export is needed for tests that provide their own mock for connect()
export { RolesScreenWrap as RolesScreenWrap4Test };

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RolesScreenWrap));
